/*
  $route.path 字符串，等于当前路由对象的路径，会被解析为绝对路径，如 '/home/news' 。
  $route.params 对象，包含路由中的动态片段和全匹配片段的键值对
  $route.query 对象，包含路由中查询参数的键值对。例如，对于 /home/news/detail/01?favorite=yes ，会得到$route.query.favorite == 'yes' 。
  $route.router 路由规则所属的路由器（以及其所属的组件）。
  $route.matched 数组，包含当前匹配的路径中所包含的所有片段所对应的配置参数对象。它会将嵌套它的父路由都匹配出来。
  $route.name  当前路径的名字，如果没有使用具名路径，则名字为空。
*/
import Vue from 'vue'
// import home from '@/common/area/home'
import index from '@/pages/views/home/home'
// import fun from '@/common/area/fun'
/* eslint-disable */
import Router from 'vue-router'
import frontViews from '@/router/views.js';
import enFrontViews from '@/router/enViews.js';
import AdminRouter from '@/router/admin/index';
import {
  localStorage
} from '@/common/util/storage';

let mainRouter = [{
    path: '/',
    redirect: {
      path: '/index'
    },
    meta: {
      title: '国家农机装备创新中心'
    },
    component: index
  },
  ...frontViews,
  ...enFrontViews,
  ...AdminRouter
]
Vue.use(Router)
const router = new Router({
  mode: 'hash',
  routes: mainRouter
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    window.document.title = to.meta.title;
  } else {
    window.document.title = '国家农机装备创新中心-后台管理'
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js